import { usePageTracking } from "@/hooks/usePageTracking";
import { Outlet } from "react-router-dom";

export const TrackerPage = () => {
  usePageTracking();
  return <Outlet />;
};
